import type { UserWithRoles } from '@portal/api-models';

/**
 * The default email to be used when a given user is not present.
 */
export const DEFAULT_CONTACT_EMAIL = 'partnersupport@engine.tech';

export const getUserFullName = (user?: UserWithRoles) =>
  (user && `${user.firstName} ${user.lastName}`) || '';
